import React, { Component } from 'react';
//import NavbarApp from './Navbar'
//import Footer from './Footer'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Jumbotron,
  CardDeck,
  Container,
  Row,
  Col
} from "reactstrap";

class Portal extends Component {
  state = {
  }

  componentDidMount() {

    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    //this.refs.main.scrollTop = 0;
  }


  render() {
    return (
      <div>

        <main ref="main" className="portalPage">
          <section className="section-profile-cover section-shaped bg-light" >
            <Container className="">
              <Row className="justify-content-center">
                <Col xs="12">
                  <Jumbotron className="shadow-lg">
                    <h1 className="display-3">CalBit Portal</h1>
                    <p className="lead">A DOT and BIT Inspection Platform. We connect right Customers with right Inspectors
                     and right Mechanics. </p><hr className="my-2" />

                    <p className="lead">
                      <Button color="primary" href="http://calbit.com/" target="blank">Learn More</Button>
                    </p>
                  </Jumbotron>
                </Col>
              </Row>
            </Container>


          </section>

          <section className="bg-light section section-lg py-2">
            <Container>
              <Row className="justify-content-center py-2">
                <Col lg="12">
                  <CardDeck>

                    <Card className="card-lift--hover shadow border-0">
                      <CardHeader> <h6 className="text-primary text-uppercase">Getting Started</h6></CardHeader>
                      <CardBody className="py-5">  <p className="description mt-0"> We provide complete consulting services, 90-day inspections, full fleet repair, and full fleet maintenance services. Call or message me on facebook. (714) 476-6537
                     </p>
                        <Button
                          className="mt-4 mb-4"
                          color="primary"
                          href=""
                          onClick={e => e.preventDefault()}>
                          Learn More
                    </Button>

                      </CardBody>
                    </Card>


                    <Card className="card-lift--hover shadow border-0">
                      <CardHeader> <h6 className="text-success text-uppercase">Schedule Inspection</h6></CardHeader>
                      <CardBody className="py-5">  <p className="description mt-0"> Find best community rated Inspectors and Mechanics. CalBit provides complete end to end solution for your DOT/BIT Inspections and maintenance needs. Don’t over complicate it.
               </p>
                        <Button
                          className="mt-4"
                          color="success"
                          href=""
                          onClick={e => e.preventDefault()}>
                          Schedule Inspections
               </Button>

                      </CardBody>
                    </Card>


                    <Card className="card-lift--hover shadow border-0">
                      <CardHeader> <h6 className="text-danger text-uppercase">Register As Inspector</h6></CardHeader>
                      <CardBody className="py-5">  <p className="description mt-0"> Become a CalBit certified/approved Inspector. CalBit Platform connects right customers with right Inspectors. Find you next inspection at your fingertips. We provide all required tooling and support.
                     </p>
                        <Button
                          className="mt-4"
                          color="danger"
                          href=""
                          onClick={e => e.preventDefault()}>
                          Register As Inspector
                    </Button>

                      </CardBody>
                    </Card>

                  </CardDeck>
                </Col>
              </Row>
            </Container>

          </section>
        </main>

      </div>
    )
  }
}


export default Portal;


// WEBPACK FOOTER //
// ./src/pages/PortalPage.js